"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hydrogen_react_1 = require("@shopify/hydrogen-react");
var config_1 = require("../../config");
var withShopifyProvider = function (Component) { return function (props) {
    return ((0, preact_1.h)(hydrogen_react_1.ShopifyProvider, { storeDomain: "https://".concat(config_1.config.shopifyDomain), storefrontToken: config_1.config.shopifyPublicStorefrontApiToken, storefrontApiVersion: config_1.config.shopifyPublicStorefrontApiVersion, countryIsoCode: 'US', languageIsoCode: 'EN' },
        (0, preact_1.h)(Component, __assign({}, props))));
}; };
exports.default = withShopifyProvider;
